import { lazy, Suspense } from 'react';
import { HashRouter, Routes, Route, useLocation } from 'react-router-dom';
import { DataVersionGate } from './providers/DataVersionGate';
import './adm-variable.scss';

const SettingHall = lazy(() => import('./pages/generated/setting-hall'));
const PlanList    = lazy(() => import('./pages/generated/plan-list'));
const PlanDetail  = lazy(() => import('./pages/generated/plan-detail'));
const Usage       = lazy(() => import('./pages/generated/guide/Usage'));

function Loading() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-gray-400">加载中...</div>
    </div>
  );
}

function AppContent() {
  const { pathname } = useLocation();
  const shellClassName = pathname === '/plan-list'
    ? 'app-shell app-shell--plan-list'
    : 'app-shell';

  return (
    <div className={shellClassName}>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/"             element={<SettingHall />} />
          <Route path="/setting-hall" element={<SettingHall />} />
          <Route path="/plan-list"    element={<PlanList />} />
          <Route path="/plan-detail"  element={<PlanDetail />} />
          <Route path="/guide/usage"  element={<Usage />} />
        </Routes>
      </Suspense>
    </div>
  );
}

function App() {
  return (
    <DataVersionGate>
      {() => (
        <HashRouter>
          <AppContent />
        </HashRouter>
      )}
    </DataVersionGate>
  );
}

export default App;
